import { ImporterEvent } from './importer-event';
import { ImporterEventType } from './importer-event-type';

export class ShowBackButtonEvent implements ImporterEvent {
  type = ImporterEventType.ShowBackButton;

  constructor(public show: boolean) {}
}
